import { ReactNode } from 'react'

type Props = {
  children?: ReactNode
  [x: string]: any
}
const ValidationMessage = ({ children, ...rest }: Props) => {
  return (
    <p className="mt-1 text-red-500" {...rest}>
      {children}
    </p>
  )
}
export default ValidationMessage
